import axios from 'axios'
import { Message } from 'element-ui'
import store from '@/store'
import { aiApiRoot } from '@/utils/server'

// create an axios instance
const service = axios.create({
  baseURL: aiApiRoot, // url = base url + request url
  // withCredentials: true, // send cookies when cross-domain requests
  timeout: 60000 // request timeout
})

// request interceptor
service.interceptors.request.use(
  config => {
    // do something before request is sent

    if (store.getters.token) {
      // let each request carry token
      // ['X-Token'] is a custom headers key
      // please modify it according to the actual situation
      config.headers['Authorization'] = 'Bearer ' + store.getters.token
    }
    config.headers["Accept-Language"] = store.getters.language
    return config
  },
  error => {
    // do something with request error
    console.log(error) // for debug
    return Promise.reject(error)
  }
)

// response interceptor
service.interceptors.response.use(
  /**
   * If you want to get http information such as headers or status
   * Please return  response => response
  */

  /**
   * Determine the request status by custom code
   * Here is just an example
   * You can also judge the status by HTTP Status Code
   */
  response => {
    const res = response.data

    // if the custom code is not 20000, it is judged as an error.
    if (!res.success) {
      const message = res.error && res.error.message ? res.error.message : 'Error'
      Message({
        message: message,
        type: 'error',
        duration: 5 * 1000
      })
      return Promise.reject(new Error(message))
    } else {
      return res
    }
  },
  error => {
    let message = error.message;
    if (error.response && error.response.data && error.response.data.error && error.response.data.error) {
      message = error.response.data.error.message;
      // const code = error.response.data.error.code;
      // if (code === 10004 || code === 10005) {
      //   MessageBox.confirm('You have been signed out, you can cancel to stay on this page, or sign in again', 'Confirm signout', {
      //     confirmButtonText: 'Re-Signin',
      //     cancelButtonText: 'Cancel',
      //     type: 'warning'
      //   }).then(() => {
      //     store.dispatch('user/resetToken').then(() => {
      //       location.reload()
      //     })
      //   }).catch(() => { })
      //   return Promise.resolve(error.response.data)
      // }
    }
    console.log(error) // for debug
    if (axios.isCancel(error)) {
      return;
    }
    Message({
      message: message,
      type: 'error',
      duration: 5 * 1000
    })
    return Promise.reject(error)
  }
)

export default service
